Platform.Deferred.execute(setCheckoutScript);

var giftWrappingOption = -1;
var root;

function setCheckoutScript() {
    root = $('body').data('root');

    var fbPixelEnabled = $('#checkout-form').data("fb-pixel");

    $('#checkout-info').click(function (e) {
        e.preventDefault();
        $('#checkout-modal').modal("show");
    });

    // hide delivery address
    if ($('#use-billing-cbx').prop('checked')) {
        $('#delivery-wrapper').hide();
        $("#save-address-wrapper").hide();
        $(".pick-existing-address").hide();
    }
    else {
        $('#delivery-wrapper').show();
        $("#save-address-wrapper").show();
        $(".pick-existing-address").show();
    }

    //$(document).on('click', '#checkout-cart a.cart-remove', function () {
    //    var cartItemId = $(this).closest('tr').data('id');
    //    $.post(root + 'Cart/RemoveItem', { id: cartItemId }, ItemUpdated, 'json');
    //    return false;
    //});

    //$(document).on('change', '#checkout-cart select.cart-qty', function () {
    //    var cartItemId = $(this).closest('tr').data('id');
    //    var quantity = $(this).val();
    //    $.post(root + 'Cart/UpdateItemQuantity', {
    //        id: cartItemId,
    //        quantity: quantity
    //    }, ItemUpdated, 'json');
    //});

    //$(document).on("click", "#discount-btn", function (e) {
    //    AddDiscountCode();
    //    return false;
    //});

    //$(document).on('click', '.pf-checkout-cart-table .pf-qty-btn-minus', function (e) {
    //    e.preventDefault();
    //    var cartItemId = $(this).closest('tr').data('id');
    //    var wrapper = $(this).closest('.pf-qty-wrapper');
    //    var qtyTbx = wrapper.find('.pf-qty-select');
    //    var qty = Number(qtyTbx.val());
    //    if (qty > 1) {
    //        qty--;
    //        qtyTbx.val(qty);
    //        //UpdateTopCartQty(cartItemId, qty);
    //        UpdateItemCartQty(cartItemId, qty);
    //    }
    //});

    //$(document).on('click', '.pf-checkout-cart-table .pf-qty-btn-plus', function (e) {
    //    e.preventDefault();
    //    var cartItemId = $(this).closest('tr').data('id');
    //    var wrapper = $(this).closest('.pf-qty-wrapper');
    //    var qtyTbx = wrapper.find('.pf-qty-select');
    //    var qty = Number(qtyTbx.val());
    //    qty++;
    //    qtyTbx.val(qty);
    //    //UpdateTopCartQty(cartItemId, qty);
    //    UpdateItemCartQty(cartItemId, qty);
    //});

    //// Add handlers for top cart events, as when top cart changed need to refresh checkout cart
    //$(document).on('itemRemoved.topCart.platform', function (e, data) {
    //    if (data.result === 'ok')
    //        location.reload();
    //});
    //$(document).on('itemUpdated.topCart.platform', function (e, data) {
    //    if (data.result.substring(0, 2) === 'ok')
    //        location.reload();
    //});

    var userLoggedIn = $('#checkout-form').data("logged-in");
    if (userLoggedIn == 'True') {
        SetBillingAddressManual();
    }

    $('#postcode_lookup').setupPostcodeLookup({
        api_key: 'ak_mmf2ua90pYdOfVBCry3SyDh5qKKOL',
        input_class: 'w-input input m-input postcode-lookup-input billPostcode',
        button_class: 'site-button postcode-lookup-btn pf-btn pf-btn-md pf-btn-primary',
        dropdown_class: 'w-input input m-input postcode-lookup-dropdown',
        //input: '#postcode-lookup-input',
        //button: '#postcode-lookup-btn',
        //dropdown_container: '#postcode-lookup-dropdown',
        output_fields: {
            line_1: '#billAddr1',
            line_2: '#billAddr2',
            //line_3: '#line3',
            post_town: '#billTown',
            county: '#billCounty',
            postcode: '#billPostcode'
        },
        onLookupSuccess: function (data) { },
        onLookupError: function () {/* Your custom code */ },
        onAddressSelected: function (elem, index) {
            //var addressTxt = $('#billAddr1').val() + "\n" + $('#billAddr2').val();
            //$('#billing-auto-address-tbx').val(addressTxt);
            //$('#address-manually-btn').hide();
            //$('#address-wrapper').slideDown();
        }
    });

    $('#delivery-postcode_lookup').setupPostcodeLookup({
        api_key: 'ak_mmf2ua90pYdOfVBCry3SyDh5qKKOL',
        input_class: 'w-input input m-input postcode-lookup-input delPostcode',
        button_class: 'w-button site-button postcode-lookup-btn',
        dropdown_class: 'w-input input m-input postcode-lookup-dropdown',
        //input: '#postcode-lookup-input',
        //button: '#postcode-lookup-btn',
        //dropdown_container: '#postcode-lookup-dropdown',
        output_fields: {
            line_1: '#delAddr1',
            line_2: '#delAddr2',
            //line_3: '#line3',
            post_town: '#delTown',
            county: '#delCounty',
            postcode: '#delPostcode'
        },
        onLookupSuccess: function (data) { },
        onLookupError: function () {/* Your custom code */ },
        onAddressSelected: function (elem, index) {
            //var addressTxt = $('#billAddr1').val() + "\n" + $('#billAddr2').val();
            //$('#billing-auto-address-tbx').val(addressTxt);
            //$('#address-manually-btn').hide();
            //$('#address-wrapper').slideDown();
        }
    });

    $('#billing-address-manual-btn').click(function () {
        SetBillingAddressManual();
    });

    $('#billing-address-auto-btn').click(function () {
        SetBillingAddressAuto();
    });

    $('#billCountry').change(function (e) {
        e.preventDefault();
        if ($('#billCountry').val() != "GB") { // can only use lookup for UK addresses at the moment
            SetBillingAddressManual();
        }
        else {
            SetBillingAddressAuto();
        }
        GetDeliveryOptions();
        return false;
    });

    $('#delCountry').change(function (e) {
        e.preventDefault();
        if ($('#delCountry').val() != "GB") { // can only use lookup for UK addresses at the moment
            SetDeliveryAddressManual();
        }
        else {
            SetDeliveryAddressAuto();
        }
        GetDeliveryOptions();
        return false;
    });

    $('#delivery-address-manual-btn').click(function () {
        SetDeliveryAddressManual();
    });

    $('#delivery-address-auto-btn').click(function () {
        SetDeliveryAddressAuto();
    });

    $('.billPostcode').change(function () {
        GetDeliveryOptions();
    });
    $('.delPostcode').change(function () {
        GetDeliveryOptions();
    });

    $(document).on("click", ".deliveryOptionRbn", function (e) {
        var deliveryOptionId = $('input[name=deliveryOption]:radio:checked').val();
        GetDeliveryOptions(deliveryOptionId);
        return false;
    });


    $('#use-billing-cbx').click(function () {
        if ($(this).prop('checked')) {
            $('#delivery-wrapper').slideUp();
            $("#save-address-wrapper").hide();
            $(".pick-existing-address").hide();
        }
        else {
            $('#delivery-wrapper').slideDown();
            $("#save-address-wrapper").show();
            $(".pick-existing-address").show();
        }
        var useBilling = $('#use-billing-cbx').prop('checked');
        var billCountry = $('#billCountry').val();
        var delCountry = $('#delCountry').val();
        //$.post("@Url.Action("ChangeDelivery", "Cart")", {useBilling: useBilling, billCountry: billCountry, delCountry: delCountry}, CountryChanged, "json");
        GetDeliveryOptions();
    });

    $("#makePaymentBtn").click(function () {
        if (validateInput()) {
            $("#makePaymentBtn").text("Processing Order..");
            //$("#makePaymentBtn").css("color", "#000");
            // check stock
            if (fbPixelEnabled == "True") {
                fbq_ProcessPayment();
            }
            $('#checkout-form').submit();
        }
        else {
            $('#validate-errors').fadeIn();
        }
        return false;
    });

    $('#discount-input-tbx').blur(function () {
        $('#voucher-not-found').fadeOut();
    });

    $('#sagepayBtn').click(function () {
        $('#makePaymentBtn .pf-place-order-btn-text').text('Make Payment');
        $('#customer-details').slideDown();
        $('#delivery-note').show();
        $('#billing').slideDown();
        $('#useBillingBtn').show();
        $('#use-billing-cbx').prop('checked', true);
        $('#delivery-wrapper').hide();
        $('#delivery .checkout-step').text("4) ");
        GetDeliveryOptions();
    });
    $('#paypalBtn').click(function () {
        $('#makePaymentBtn .pf-place-order-btn-text').text('Make Payment');
        //$('#customer-details').slideUp();
        //$('#delivery-note').hide();
        $('#use-billing-cbx').prop('checked', false);
        $('#useBillingBtn').hide();
        $('#billing').slideUp();
        $('#delivery-wrapper').show();
        $('#delivery .checkout-step').text("3) ");
        GetDeliveryOptions();
    });
    $('#payOnAccountBtn').click(function () {
        $('#makePaymentBtn .pf-place-order-btn-text').text('Place Order');
        $('#customer-details').slideDown();
        $('#delivery-note').show();
        $('#billing').slideDown();
        $('#useBillingBtn').show();
        $('#use-billing-cbx').prop('checked', true);
        $('#delivery-wrapper').hide();
        $('#delivery .checkout-step').text("4) ");
        GetDeliveryOptions();
    });

    //var sagepay = $('#checkout-form').data('sagepay');
    //var paypal = $('#checkout-form').data('paypal');
    //if(sagepay == "True" && paypal == "True")
    //{
    //    $('#paypalBtn').trigger("click");
    //}
    $('#terms-cbx').click(function () {
        if ($('#terms-cbx').prop('checked')) {
            ValidNotes("", false);
        }
    });

    //$(document).on("click", ".editMessageBtn", function (e) {
    //    var id = $(this).closest('tr').attr('id');
    //    id = id.replace("prod-", "");
    //    var txt = $(this).prev('.personalMessageTxt').val();
    //    $(this).hide();
    //    $.post("@Url.Action("UpdatePersonalMessage", "Cart")", { pID: id, pMessageText: txt }, PersonalMessageUpdated, "json");
    //    return false;
    //});

    $('.gift-option-radio').change(function () {
        giftWrappingOption = $(this).val();
        GetDeliveryOptions();
    });
    $("#save-address").on("click", function ()
    {        
        var delAddr1 = $("#delAddr1").val();
        var delAddr2 = $("#delAddr2").val();
        var delTown = $("#delTown").val();
        var delCounty = $("#delCounty").val();
        var delPostcode = $("#delPostcode").val();
        var userId = $("#save-address-wrapper").data("user-id");
        var delCountry = $("#delCountry").val();
        var addressId = $("#save-address-wrapper").data("address-id");
        console.log(userId);
        $.post(root + "UserAccount/SaveDeliveryAddress", {
            userId: userId, 
            delAddr1: delAddr1,
            delAddr2: delAddr2,
            delTown: delTown,
            delCounty: delCounty,
            delPostcode: delPostcode
        }, function (data) {
            alert(data.result);
        });
       
        //SaveAddress();

    });
        $('#addressPicker').on("change", function ()
    {
        var id = this.value;
        var userId = $("#userId").val();
        
        $.post(root+ "UserAccount/GetAddress",
            {
                addressId: id,
                userId: userId
            },
            function (data, status) {
                if (data.AddressId > 0) {
                    $('#delAddr1').val(data.Address1);
                    $('#delAddr2').val(data.Address2);
                    //$('#newAddressId').val(data.AddressId);
                    $('#delCounty').val(data.County);
                    $('#delCountry').val(data.Country);
                    $('#delPostcode').val(data.Postcode);
                    $('#delTown').val(data.Town);          
                    SetDeliveryAddressManual();
                }
                else {
                    alert('Error: ' + err);
                }
            });
    });
    $('#addressPicker2').on("change", function ()
    {
        var id = this.value;
        var userId = $("#userId").val();
        
        $.post(root+ "UserAccount/GetAddress",
            {
                addressId: id,
                userId: userId
            },
            function (data, status) {
                if (data.AddressId > 0) {
                    $('#billAddr1').val(data.Address1);
                    $('#billAddr2').val(data.Address2);
                    //$('#newAddressId').val(data.AddressId);
                    $('#billCounty').val(data.County);
                    $('#billCountry').val(data.Country);
                    $('#billPostcode').val(data.Postcode);
                    $('#billTown').val(data.Town);          
                    SetBillingAddressManual();
                }
                else {
                    alert('Error: ' + err);
                }
            });
    });
    // Init after events registered
    GetDeliveryOptions();
    SetUseBilling();
    InitPaymentMethods();
}
function SaveAddress()
{
        
}
function SetUseBilling() {
    if ($('#use-billing-cbx').prop('checked')) {
        $('#delivery-wrapper').hide();
    }
    else {
        $('#delivery-wrapper').show();
    }
}

//function ItemUpdated(data) {
//    if (data.result == "ok") {
//        location.reload();
//    } else if (data.result == "ok-stock-limited") {
//        //$('#site-msg-modal-header').html("Information");
//        //$('#site-msg-modal-msg').html("Sorry there are only " + data.qty + " of these items available in stock.");
//        //$('#site-msg-modal').modal('show');
//        alert("Sorry there are only " + data.qty + " of these items available in stock.");
//        location.reload();
//    } else if (data.result == "ok-out-of-stock") {
//        //$('#site-msg-modal-header').html("Information");
//        //$('#site-msg-modal-msg').html("Sorry this item is no longer in stock.");
//        //$('#site-msg-modal').modal('show');
//        alert("Sorry this item is no longer in stock.");
//        location.reload();
//    }
//}

//function PersonalMessageUpdated(data) {
//    if (data.result == "ok") {
//        var id = data.id;
//        var tr = $('#prod-' + id);
//        var span = $(tr).find('.ajaxResult');
//        var btn = $(tr).find('.editMessageBtn');
//        span.text("Your personal message has been updated");
//        $(btn).fadeIn();
//        $(span).fadeIn();
//        setTimeout(function () {
//            $(span).fadeOut("slow", function () {
//            });
//        }, 3000);
//    }
//}

function AddVoucherDone(data) {
    if (data.result == "ok") {
        location.reload();
    }
    else if (data.result == "fail") {
        // error
        alert("Error: " + data.err);
    }
    else if (data.msg == "order-total-not-reached") {
        $('#voucher-not-found').find('.pf-alert-msg').text("Discount only applies to orders over £" + parseFloat(data.amount).toFixed(2));
        $('#voucher-not-found').fadeIn();
    }
    else {
        $('#voucher-not-found').find('.pf-alert-msg').text("Invalid Discount Code");
        $('#voucher-not-found').fadeIn();
    }
}

function validateInput() {
    $.validity.setup({ outputMode: "summary" });

    // Start validation:
    $.validity.start();

    // PAYPAL
    if ($('#paypalBtn').prop("checked") == true) {
        $(".required-input-delivery").require();
        var email_check = /\S+@\S+\.\S+/;
        var email2 = $('#delEmail').val();
        if ($("#use-billing-cbx").prop("checked") != true) {
            if (!email_check.test(email2)) {
                ValidNotes("Please check that your email address is entered correctly.", true);
                $('#delEmail').addClass("validity-erroneous");
                return false;
            }
        }
    }

    // SAGEPAY
    if ($("#sagepayBtn").prop("checked") == true || $("#payOnAccountBtn").prop("checked") == true) {
        $(".required-input").require();
        if ($("#use-billing-cbx").prop("checked") != true) {
            $(".required-input-delivery").require();
        }
    }
    if ($("#payOnAccountBtn").prop("checked") == true) {
        var addr1 = $('#billAddr1').val();
        var town1 = $('#billTown').val();
        var county1 = $('#billCounty').val();
        var post1 = $('#billPostcode').val();
        var addr2 = $('#delAddr1').val();
        var town2 = $('#delTown').val();
        var county2 = $('#delCounty').val();
        var post2 = $('#delPostcode').val();
        if (addr1 == "" || town1 == "" || county1 == "" || post1 == "") {
            $('#idpc_input').addClass("validity-erroneous");
            ValidNotes("Please complete all the highlighted fields marked above to continue.", true);
            $('#billing-manual-wrapper').slideDown();
            return false;
        }
        if ($("#use-billing-cbx").prop("checked") != true) {
            if (addr2 == "" || town2 == "" || county2 == "" || post2 == "") {
                $('.delPostcode').addClass("validity-erroneous");
                ValidNotes("Please complete all the highlighted fields marked above to continue.", true);
                $('#delivery-manual-wrapper').slideDown();

                return false;
            }
        }
    }
    // All of the validator methods have been called:
    // End the validation session:
    var result = $.validity.end();

    if (!result.valid) {
        SetBillingAddressManual();
        SetDeliveryAddressManual();
    }

    // PAYPAL 2nd check
    if ($("#paypalBtn").prop("checked") == true) {
        if (result.valid) {

            if (($('#delCountry').val() == "US") && ($('#delCounty').val().length != 2)) {
                ValidNotes("Please use only 2 characters for U.S. States, i.e. for Florida put 'FL'.", true);
                $('#delCounty').addClass("validity-erroneous");
                return false;
            }
        }
        else {
            ValidNotes("Please complete all the highlighted fields marked above to continue.", true);
        }
    }

    // SAGEPAY 2nd check
    if ($("#sagepayBtn").prop("checked") == true || $("#payOnAccountBtn").prop("checked") == true) {
        if (result.valid) {
            // check email
            var email_check = /\S+@\S+\.\S+/;
            var email = $('#billEmail').val();
            if (!email_check.test(email)) {
                ValidNotes("Please check that your email address is entered correctly.", true);
                $('#billEmail').addClass("validity-erroneous");
                return false;
            }
            var email2 = $('#delEmail').val();
            if ($("#use-billing-cbx").prop("checked") != true) {
                if (!email_check.test(email2)) {
                    ValidNotes("Please check that your email address is entered correctly.", true);
                    $('#delEmail').addClass("validity-erroneous");
                    return false;
                }
            }

            // for US make sure only 2 characters
            if (($('#billCountry').val() == "US") && ($('#billCounty').val().length != 2)) {
                ValidNotes("Please use only 2 characters for U.S. States, i.e. for Florida put 'FL'.", true);
                $('#billCounty').addClass("validity-erroneous");
                return false;
            }
            if (($('#delCountry').val() == "US") && ($('#delCounty').val().length != 2)) {
                ValidNotes("Please use only 2 characters for U.S. States, i.e. for Florida put 'FL'.", true);
                $('#delCounty').addClass("validity-erroneous");
                return false;
            }
        }
        else {
            ValidNotes("Please complete all the highlighted fields marked above to continue.", true);
        }
    }

    var requireTerms = $('#checkout-form').data("require-terms");
    if (typeof requireTerms === "undefined" || requireTerms == "True") {
        if (result.valid) {
            if (!$('#terms-cbx').prop('checked')) {
                ValidNotes("Please confirm you agree to the website terms and conditions above.", true);
                $('.pf-terms').addClass("validity-erroneous");
                return false;
            }
        }
    }

    // Return whether it's okay to proceed with the Ajax:
    return result.valid;
}

function ValidNotes(text, show) {
    if (show) {
        $('#validNotes').html(text);
        $('#validNotes').fadeIn();
    }
    else {
        $('#validNotes').fadeOut();
    }
}

// loads delivery options view
function GetDeliveryOptions(deliveryOptionId) {
    var useBilling = $('#use-billing-cbx').prop('checked');
    var countryCode;
    var postcode;
    if (useBilling == true) {
        countryCode = $('#billCountry').val();
        postcodeBtn = $('#idpc_input').val();
        postcodeNoBtn = $('#billPostcode').val();
        if (postcodeBtn) {
            postcode = postcodeBtn;
        }
        if (postcodeNoBtn) {
            postcode = postcodeNoBtn;
        }

    }
    else {
        countryCode = $('#delCountry').val();
        postcodeBtn = $('.delPostcode').val();
        postcodeNoBtn = $('#delPostcode').val();
        if (postcodeBtn) {
            postcode = postcodeBtn;
        }
        if (postcodeNoBtn) {
            postcode = postcodeNoBtn;
        }
    }

    $.post(root + "Checkout/GetDeliveryOptionsAndTotals", {
        countryCode: countryCode,
        postcode: postcode,
        deliveryOptionId: deliveryOptionId,
        giftWrappingOptionId: giftWrappingOption
    }, function (data) {
        $('#delivery-options-frame').html(data);
        var deliveryOptionsExist = $('input[name=deliveryOption]').length > 0;
        if (deliveryOptionsExist)
            $('#makePaymentBtn').show();
        else
            $('#makePaymentBtn').hide();
    });
}

function InitPaymentMethods() {
    $("#paymentMethods input:radio:first").prop('checked', true).click();
}


// address lookup 
function SetBillingAddressAuto() {
    $('#billing-manual-wrapper').slideUp();
    $('#billing-auto-wrapper').show();

}

function SetBillingAddressManual() {
    $('#billing-manual-wrapper').slideDown();
    $('#billing-auto-wrapper').hide();
}

// delivery
function SetDeliveryAddressAuto() {
    $('#delivery-manual-wrapper').slideUp();
    $('#delivery-auto-wrapper').show();

}

function SetDeliveryAddressManual() {
    $('#delivery-manual-wrapper').slideDown();
    $('#delivery-auto-wrapper').hide();
}

//function UpdateItemCartQty(cartId, qty) {
//    $.post(root + "Cart/UpdateItemQuantity", {
//        id: cartId,
//        quantity: qty
//    }, function (data) {
//        // Display warnings if relevant
//        if (data.result === 'ok-stock-limited')
//            alert('Sorry, there are only ' + data.qty + ' of these items available in stock.');
//        else if (data.result === 'ok-out-of-stock')
//            alert('Sorry, this item is no longer in stock.');

//        // Fire event
//        //$(document).trigger('itemUpdated.mainCart.platform', data);

//        // Refresh page if response OK
//        if (data.result.substring(0, 2) === 'ok') {
//            location.reload();
//            //GetTopCart();
//            //SetCartQty();
//        }
//    }, 'json');
//}

function CheckMinimumOrder() {
    $.get(root + 'Checkout/ReachedMinimumOrder', function (response) {
        var $makePaymentArea = $('.pf-checkout-actions');
        if (response.reachedMinimumOrder)
            $makePaymentArea.show();
        else
            $makePaymentArea.hide();
    });
}

function CheckItemsCount() {
    $.get(root + 'Checkout/CheckItemsCount', function (response) {
        var $makePaymentArea = $('.pf-checkout-actions');
        if (response.hasItems)
            $makePaymentArea.show();
        else
            $makePaymentArea.hide();
    });
}

// Register handlers for cart actions
$(document).on('itemUpdated.cart.platform', function (event, data) {
    GetDeliveryOptions();
    CheckMinimumOrder();
    CheckItemsCount();
});

$(document).on('itemRemoved.cart.platform', function (event, data) {
    GetDeliveryOptions();
    CheckMinimumOrder();
    CheckItemsCount();
});

$(document).on('discountUpdated.cart.platform', function (event, data) {
    GetDeliveryOptions();
    CheckMinimumOrder();
    CheckItemsCount();
});